import { Guid, SerializableObject } from '../../common-react/core';

import { PaymentCardType } from '../other/payment-card-type.enum';

/**
 * NOTE: Existing cards have the first 12 digits of the card number replaced with asterisk and the security code is null.
 */
export class PaymentCard extends SerializableObject {
  public id: Guid;

  public cardholderName: string;
  public cardNumber: string;
  public securityCode: string | null;
  public expiryMonth: number;
  public expiryYear: number;
  public cardType: PaymentCardType;
  public cardVerificationRawResponse?: string;
}
